export default "__VITE_ASSET__d62d7d4b__"